import React, { Component } from "react";
import Header from "../component/Header";
import Breadcrumb from "../component/Breadcumb";
import Footer from "../component/Footer";

import newbg from "../assets/img/bg/newbg.svg"
import newbgactive from "../assets/img/bg/newbgactive.svg"
import { BASEURL } from "../../Global";
import Modal from "../component/Modal";

class Gallary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedGallary: "",
            gallaryData: [],
            currentIndex: 0,
            showModal: false
        };
    }

    async fetchGallary(value) {
        this.setState({ gallaryData: [], selectedGallary: value })
        try {
            await fetch(`${BASEURL}/searchandlistgallery`, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    category: value
                })
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ gallaryData: responseJson.data, })
                            } else {
                                this.setState({ gallaryData: [], selectedGallary: "" })
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        this.setState({ gallaryData: [], selectedGallary: "" })
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }

    componentDidMount() {
        document.title = "Gallary - My Jainism";
        this.fetchGallary("")
    }

    handleImageClick = (index) => {
        this.setState({ currentIndex: index, showModal: true });
    }

    handleNextClick = () => {
        const { currentIndex } = this.state;
        const nextIndex = currentIndex === this.state.gallaryData.length - 1 ? 0 : currentIndex + 1;
        this.setState({ currentIndex: nextIndex });
    }

    handlePrevClick = () => {
        const { currentIndex } = this.state;
        const prevIndex = currentIndex === 0 ? this.state.gallaryData.length - 1 : currentIndex - 1;
        this.setState({ currentIndex: prevIndex });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <Breadcrumb title={"Project Gallery"} />
                <div className="project-section bg-smoke space-top space-extra-bottom">
                    <div className="container pb-10">
                        <div className="project-menu text-center mb-40 filter-menu-active">
                            <button onClick={() => this.fetchGallary("")} className={this.state.selectedGallary === "" && "active"}>All Zone <img className="btn-bg" src={newbg} alt="btn-bg" /><img className="btn-active-bg" src={newbgactive} alt="btn-active-bg" /></button>
                            <button onClick={() => this.fetchGallary("Outdoor")} className={this.state.selectedGallary === "Outdoor" && "active"}>Outdoor <img className="btn-bg" src={newbg} alt="btn-bg" /><img className="btn-active-bg" src={newbgactive} alt="btn-active-bg" /></button>
                            <button onClick={() => this.fetchGallary("Party")} className={this.state.selectedGallary === "Party" && "active"}>Party <img className="btn-bg" src={newbg} alt="btn-bg" /><img className="btn-active-bg" src={newbgactive} alt="btn-active-bg" /></button>
                            <button onClick={() => this.fetchGallary("Event")} className={this.state.selectedGallary === "Event" && "active"}>Events <img className="btn-bg" src={newbg} alt="btn-bg" /><img className="btn-active-bg" src={newbgactive} alt="btn-active-bg" /></button>
                        </div >
                        <div className="row g-20 justify-content-center filter-active">
                            {this.state.gallaryData.map((item, index) => (
                                <div key={index} className="col-xl-3 col-lg-4 col-sm-6 filter-item cat-1" data-wow-delay="0.1s">
                                    <div className="project-card">
                                        <div className="project-img">
                                            <img src={item.image} alt="project-img" />
                                        </div>
                                        <a onClick={() => this.handleImageClick(index)} className="plus-btn popup-image">+</a>
                                    </div>
                                </div>
                            ))}

                        </div>
                        {
                            this.state.showModal && (
                                <Modal
                                    imageUrl={this.state.gallaryData[this.state.currentIndex].image}
                                    onNext={this.handleNextClick}
                                    onPrev={this.handlePrevClick}
                                    onCancel={this.handleCloseModal}
                                />
                            )
                        }
                    </div >


                </div >
                <Footer />
            </React.Fragment >
        );
    }
}

export default Gallary;
